import axios from '@/plugins/axios'
import util from '@/services/util'

const customerApiEndPoint = 'admin/customer'

export default {
    namespaced: true,

    state: {
        customers: [],
        total: 0
    },

    getters: {
        getCustomerById: state => async id => {
            return axios.get(`${customerApiEndPoint}/${id}`)
        },

        getCustomerRegisterTypeById: state => id => {
            const customer = state.customers.find(customer => customer.id === id)

            if (customer) {
                if (customer.lineId) {
                    return 'Line'
                } else if (customer.facebookId) {
                    return 'Facebook'
                } else if (customer.googleId) {
                    return 'Google'
                } else if (customer.appleId) {
                    return 'Apple'
                }

                return 'Andamanda'
            }

            return ''
        }
    },

    mutations: {
        setCustomers (state, customers) {
            state.customers = customers
        },

        setCustomerTotal (state, total) {
            state.total = total
        }
    },

    actions: {
        async fetchCustomers ({ commit }, query) {
            const response = await axios.get(util.buildUrlWithQuery(customerApiEndPoint, query))
            const { customers, total } = response

            commit('setCustomers', customers)
            commit('setCustomerTotal', total)
        },

        async updateCustomer (context, payload) {
            await axios.patch(`${customerApiEndPoint}/${payload.id}`, payload)
        }
    }
}
